'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.millisecondFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/millisecondFromNow.js
// module id = 697
// module chunks = 0